<template>
  <div>
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>

    <!-- Upload Face Scan Button -->
    <div class="d-flex justify-content-start mb-3">
      <button
        class="btn create-facescan-btn mt-3"
        @click="showUploadScanModal = true"
      >
        Upload A New Face Scan
      </button>
    </div>
    <!-- Success Messages -->
     <!-- Success Messages -->
      <div v-if="successMessage || deleteFacescanMessage" class="alert alert-success" style="transform: translateX(2.5rem); width: 50% !important">
        <i class="fa fa-info-circle"></i>
        <span class="mx-2">
          {{ successMessage || deleteFacescanMessage }}
        </span>
      </div>
    <!-- Patient Details -->
    <div class="patient-details-container">
      <div class="patient-details-card">
        <div class="patient-info-row">
          <div class="info-item">
            <i class="fa fa-user"></i> <strong>Subject ID:</strong>
            {{ (patient.patient_identifier) }}
          </div>
          <div class="info-item">
            <strong>Name:</strong>
            {{ displayName(patient.name) }} {{ (patient.surname) }}
          </div>

          <div class="info-item">
            <strong>Sex:</strong>
            {{ patient.sex }}
          </div>
          <div class="info-item">
             <strong>Ethnicity:</strong>
            {{ patient.ethnicity }}
          </div>
          <div class="info-item">
            <strong>Date of Birth:</strong>
            {{ patient.dob }}
          </div>
          <div class="text-center">
            <i class="icon-docs" @click="openPatientNotesModal(patient)"></i>
          </div>
        </div>
      </div>

      <div class="spacer"></div>

      <!-- Upload Face Scan Modal -->
      <div v-if="showUploadScanModal" class="modal-overlay">
        <div class="modal-content-upload">
          <button class="close-modal-btn" @click="showUploadScanModal = false">
            &times;
          </button>
          <FaceScanComponent
            :patient_id="patient.id"
            @upload-success="handleUploadSuccess"
          />
        </div>
      </div>

      <!-- Face Scan Records -->
      <h1 class="title">Face Scan Records</h1>
      <div class="face-scan-container">
        <!-- Loading Indicator -->
        <p v-if="loading">Loading face scan data...</p>
        <!-- Error Message -->
        <p v-else-if="error">{{ error }}</p>

        <div v-else-if="faceScans.length === 0">
          <div class="alert alert-info mt-2" :style="{ width: '27%' }">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            No Face scans found for this patient.
          </div>
        </div>

        <!-- Face Scans Display -->
        <div
          class="face-scan-box"
          v-for="(scan, index) in faceScans"
          :key="index"
          @click="
            selectFacescan_Texture(
              scan.id,
              scan.scan_date,
              scan.imaging_modality
            )
          "
        >
          <div class="row">
            <div class="scan-field">
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <strong>Scan Date: </strong> {{ scan.scan_date }}
            </div>
            <div class="scan-field">
              <i class="fa fa-camera" aria-hidden="true"></i>
              <strong>Imaging Modality: </strong> {{ scan.imaging_modality }}
            </div>
             <!-- Delete Icon -->
              <i
                class="fa fa-trash delete-icon ml-2"
                @click.stop="openDeleteFacescanModal(scan.id)"
                title="Delete Face Scan"
                style="cursor: pointer; margin-left: auto;"
              ></i>
          </div>
        </div>

          <!-- Delete Confirmation Modal -->
          <div v-if="showDeleteFacescanPopup" class="popup-overlay">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-headerDelete">
                  <h5 class="title" id="largeModalLabel">Confirm delete</h5>
                </div>
                <div class="modal-body">
                  Are you sure you want to delete this facescan?
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="confirmDeleteFacescan"
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="closeDeleteFacescanModal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>

        <!-- Brain Records Section === -->
        <h2 class="brain-online-heading">BRAIN-Online</h2>
        <div class="brain-iframe-container">
          <iframe
            class="brain-iframe"
            src="https://research.sc/participant/login/dynamic/6E1C35D8-9F3C-4234-A2A9-B6187B6B90FF"
            title="BRAIN-Online"
            frameborder="0"
            loading="lazy"
            allowfullscreen
            sandbox="allow-forms allow-same-origin allow-scripts allow-popups"
          ></iframe>
        </div>

        <!-- Report Records -->
        <h1 class="report-title">Report Records</h1>
        <div class="report-container">
          <div
            v-if="showNoReportsMessage"
            class="alert alert-info mt-2"
            :style="{ width: '27%' }"
          >
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            No FASD reports found for this patient.
          </div>

          <p v-if="loadingReports">Loading report data...</p>

          <!-- Error -->
          <p v-else-if="reportError">{{ reportError }}</p>

          <!-- Reports Records -->
          <div
            v-else-if="
              reports.length === 0 && !reportError && !showNoReportsMessage
            "
          >
            <p>There are no reports for this patient.</p>
          </div>

          <div v-else>
            <div class="report-box" v-for="report in reports" :key="report.id">
              <div class="row">
                <div class="report-field">
                  <i
                    class="fa fa-calendar"
                    :style="{ color: '#1f983b' }"
                    aria-hidden="true"
                  ></i>
                  <strong>Created At: </strong>
                  {{ new Date(report.created_at).toLocaleDateString() }}
                </div>

                <div class="report-field">
                  <strong>Format: </strong> {{ report.format }}
                </div>

                <!-- Download Report Field -->
                <div class="report-field download-section">
                  <i class="fa fa-download" aria-hidden="true"></i>
                  <strong
                    @click="downloadReport(report)"
                    class="download-link"
                    >Download Report</strong
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal for Patient Notes -->
        <div v-if="showModal" class="modal-overlay">
          <div class="modal-content">
            <span class="close-button" @click="closeModal">&times;</span>
            <h5>Notes for {{ displayName(patient.name) }} {{ (patient.surname) }}</h5>

            <!-- Notes Section -->
            <div class="notes-section">
              <div v-if="patientNotes.length">
                <div
                  v-for="note in patientNotes"
                  :key="note.id"
                  class="note-item d-flex justify-content-between align-items-center"
                >
                  <div v-if="editingNote && editingNote.id === note.id">
                    <textarea
                      v-model="newNote"
                      rows="4"
                      class="form-control-edit"
                      placeholder="Edit your note..."
                    ></textarea>
                  </div>
                  <div v-else>
                    <span>{{ note.note }}</span>
                  </div>
                  <div>
                    <i
                      class="fa fa-pencil edit-icon ml-2"
                      @click="editPatientNote(note)"
                    ></i>
                    <i
                      class="fa fa-trash delete-icon ml-2"
                      @click="deletePatientNote(note)"
                    ></i>
                  </div>
                </div>
              </div>

              <div v-if="addingNote" class="d-flex flex-column px-2">
                <textarea
                  v-model="newNote"
                  rows="4"
                  class="form-control-edit"
                  placeholder="Write a new note..."
                ></textarea>
                <button class="modalbutton mt-3" @click="submitNewPatientNote">
                  Add Note
                </button>
              </div>

              <div
                v-else-if="!patientNotes.length && !addingNote"
                class="d-flex justify-content-between align-items-center px-2"
              >
                <span>No notes available.</span>
                <i class="icon-plus add-icon ml-2" @click="addPatientNote"></i>
              </div>
            </div>

            <div v-if="editingNote" class="modal-actions">
              <button class="modalbutton mt-3" @click="savePatientNote">
                Save Note
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import FaceScanComponent from "./FaceScanComponent";

export default {
  name: "PatientDetails",
  components: {
    BreadCrumb,
    FaceScanComponent,
  },

  data() {
    return {
      patient: {
        id: null,
        name: "",
        surname: "",
        sex: "",
        dob: "",
        patient_identifier: "",
        ethnicity: "",
      },
      showUploadScanModal: false,
      successMessage: "",
      faceScanForm: {
        scan_date: "",
        imaging_modality: "",
        texture_file: null,
      },
      showModal: false,
      patientNotes: [],
      newNote: "",
      editingNote: null,
      addingNote: false,
      faceScans: [],
      // === NEW brain-related state ===
      brainScans: [],
      loadingBrains: false,
      brainError: null,
      // ================================
      reports: [],
      loading: false,
      loadingReports: false,
      showNoReportsMessage: false,
      reportError: null,
      error: null,
      selectedScanId: null,
      showDeleteFacescanPopup: false,
      deleteFacescanMessage: "",
      facescanToDelete: null,
      DeleteSuccessMessage: "",

    };
  },
  created() {
    const patientId = this.$route.params.patientId;

    if (patientId) {
      this.fetchPatientById(patientId);
      this.fetchFacescans(patientId);
      this.fetchReports(patientId);
      this.fetchBrainscans(patientId);
    } else {
      console.error("No patientId found in route params.");
    }
  },

  methods: {
    openDeleteFacescanModal(facescanId) {
      this.showDeleteFacescanPopup = true;
      this.facescanToDelete = facescanId;
    },
    displayName(v) {
      const s = (v ?? "").toString().trim();
      return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "N/A";
    },
    closeDeleteFacescanModal() {
      this.showDeleteFacescanPopup = false;
      this.facescanToDelete = null;
    },
    async confirmDeleteFacescan() {
      if (this.facescanToDelete) {
        await this.deleteFacescan(this.facescanToDelete);
        this.closeDeleteFacescanModal();
      }
    },
    async deleteFacescan(facescanId) {
      const fasdBackendURL =localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");
      try {
        const response = await fetch(
          `${fasdBackendURL}/api/facescans/facescans/${facescanId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.faceScans = this.faceScans.filter(
          (scan) => scan.id !== facescanId
        );

        this.deleteFacescanMessage = "Face scan successfully deleted!";

        setTimeout(() => {
          this.deleteFacescanMessage = "";
        }, 3000);
      } catch (error) {
        console.error("Error deleting face scan:", error);
      }
    },

    async fetchPatientById(patientId) {
      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
        const token = localStorage.getItem("userJWtoken");

        const response = await fetch(
          `${fasdBackendURL}/api/patients/withID/?patient_id=${patientId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        this.patient = {
          id: data.id,
          name: data.name,
          surname: data.surname,
          sex: data.sex,
          dob: data.dob,
          ethnicity: data.ethnicity,
          patient_identifier: data.patient_identifier,
        };

      document.title = `Patient Details - ${this.displayName(data.name)} ${this.displayName(data.surname)}`;
      } catch (error) {
        console.error("Error fetching patient details:", error);
        alert("Unable to fetch patient details.");
      }
    },
    handleUploadSuccess(newScan) {
      this.showUploadScanModal = false;
      this.successMessage = "Face Scan uploaded successfully!";
      this.faceScans.push(newScan);
      setTimeout(() => {
        this.successMessage = "";
      }, 3000);
    },
    async fetchReports(patientId) {
      this.loadingReports = true;
      this.reportError = null;
      this.showNoReportsMessage = false;

      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
        const token = localStorage.getItem("userJWtoken");

        const response = await fetch(
          `${fasdBackendURL}/api/fasdReports/underPatientID/${patientId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();

          if (errorData.detail === "No FASD reports found for this patient.") {
            this.reports = [];
            this.showNoReportsMessage = true;
          } else {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
        } else {
          const data = await response.json();
          this.reports = data;
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
        this.reportError = "Error fetching report data";
      } finally {
        this.loadingReports = false;
      }
    },
    async downloadReport(report) {
      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
        const token = localStorage.getItem("userJWtoken");

        const response = await fetch(
          `${fasdBackendURL}/api/fasdReports/${report.id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        if (report.format === "XLSX") {
          link.setAttribute("download", `Report_${this.patient.name}${this.patient.surname}.xlsx`);
        } else {
          link.setAttribute("download", `Report_${this.patient.name}${this.patient.surname}.pdf`);
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the report:", error);
        alert("Failed to download report.");
      }
    },


    async openPatientNotesModal(patient) {
      this.selectedPatient = patient;
      try {
        const response = await fetch(
          `${this.fasdBackendURL}/api/patientnotes/${patient.id}/patientnotes`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        if (!response.ok) {
          if (response.status === 404) {
            this.patientNotes = [];
          } else {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
        } else {
          const data = await response.json();
          this.patientNotes = data.length ? data : [];
        }
      } catch (error) {
        console.error("Error fetching patient notes:", error);
        this.patientNotes = [];
      }

      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.addingNote = false;
      this.editingNote = null;
      this.newNote = "";
    },

    addPatientNote() {
      this.newNote = "";
      this.addingNote = true;
    },

    async submitNewPatientNote() {
      if (!this.newNote.trim()) {
        alert("Please enter a note before submitting.");
        return;
      }

      const url = `${this.fasdBackendURL}/api/patientnotes/${this.selectedPatient.id}/patientnotes`;

      const notePayload = {
        new_patientnote: {
          patient_id: this.selectedPatient.id,
          note: this.newNote,
          owner: 0,
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(notePayload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const addedNote = await response.json();
        this.patientNotes.push(addedNote);
        this.newNote = "";
        this.addingNote = false;

        alert("Note added successfully");
      } catch (error) {
        console.error("Error adding note:", error);
        alert("Error adding note");
      }
    },

    async savePatientNote() {
      const url = this.editingNote
        ? `${this.fasdBackendURL}/api/patientnotes/${this.selectedPatient.id}/patientnotes/${this.editingNote.id}`
        : `${this.fasdBackendURL}/api/patientnotes/${this.selectedPatient.id}/patientnotes`;

      const method = this.editingNote ? "PUT" : "POST";

      try {
        const response = await fetch(url, {
          method: method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify({ note: this.newNote }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const updatedNote = await response.json();
        if (this.editingNote) {
          const index = this.patientNotes.findIndex(
            (n) => n.id === this.editingNote.id
          );
          if (index !== -1) this.patientNotes[index] = updatedNote;
        } else {
          this.patientNotes.push(updatedNote);
        }
        this.newNote = "";
        this.addingNote = false;
        this.editingNote = null;
        alert("Note saved successfully");
      } catch (error) {
        console.error("Error saving note:", error);
      }

      this.showModal = false;
    },

    editPatientNote(note) {
      this.newNote = note.note;
      this.editingNote = note;
      this.addingNote = false;
    },

    async deletePatientNote(note) {
      try {
        const response = await fetch(
          `${this.fasdBackendURL}/api/patientnotes/patientnotes/${note.id}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        if (response.ok) {
          this.patientNotes = this.patientNotes.filter((n) => n.id !== note.id);
          alert("Note deleted successfully.");
        } else {
          const errorText = await response.text();
          alert(`Error deleting note: ${errorText}`);
        }
      } catch (error) {
        console.error("Error deleting note:", error);
      }
    },

    async fetchFacescans(patientId) {
      this.loading = true;
      this.error = null;
      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
        const token = localStorage.getItem("userJWtoken");

        const response = await fetch(
          `${fasdBackendURL}/api/facescans/fromPatient/${patientId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.faceScans = data;
      } catch (error) {
        this.error = "Error fetching face scan data";
      } finally {
        this.loading = false;
      }
    },

    async fetchBrainscans(patientId) {
      this.loadingBrains = true;
      this.brainError = null;
      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
        const token = localStorage.getItem("userJWtoken");

        // NOTE: change endpoint if your backend uses a different path
        const response = await fetch(
          `${fasdBackendURL}/api/brainscans/fromPatient/${patientId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          // attempt to read error text/json for more specific handling
          try {
            const err = await response.json();
            console.error("Brain scans fetch error details:", err);
          } catch (e) {
            // ignore parse error
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        this.brainScans = data;
      } catch (error) {
        console.error("Error fetching brain scan data:", error);
        this.brainError = "Error fetching brain scan data";
      } finally {
        this.loadingBrains = false;
      }
    },

    selectFacescan_Texture(facescanId) {
      sessionStorage.setItem("patient", JSON.stringify(this.patient));
      this.$router.push({
        name: "DataProcessing",
        params: {
          facescanId,
          patientSubjectID: `${this.patient.patient_identifier}`
        },
      });
    },

    selectBrainScan(brainScanId) {
      // store patient + selected brain id for next view
      sessionStorage.setItem("patient", JSON.stringify(this.patient));
      sessionStorage.setItem("brainScanId", brainScanId);

      // route to a brain processing/detail page — change route name to whichever you use
      this.$router.push({
        name: "BrainProcessing",
        params: {
          brainScanId,
          patientSubjectID: `${this.patient.patient_identifier}`
        },
      });
    },
    // === END NEW ===
  },
};
</script>

<style scoped>
@import "./PatientDetailsComponentStyles.css";
</style>
